module.exports = __webpack_public_path__ + "img/melia-setubal.d1ea5317.jpg";